import { useLocation } from "react-router-dom";
import { useQuery } from "../../common/Hooks";
import { useCallback, useMemo } from "react";
import { Button } from "react-bootstrap";
import Icon from "./Icon";
import SortableItem from "./drag-n-drop/SortableItem";

const CLASS_NAME = 'list-group-item small flex-grow-1 d-flex flex-column justify-content-center';
const CLASS_NAME_SORTABLE = 'list-group-item small flex-grow-1 d-flex flex-row p-1 ps-2';

const ListItem = ({
    index,
    value,
    dataElement,
    onClick,
    url = "",
    active = false,
    callbacks,
    drag,
    disabled,
    css = '',
}) => {
    const location = useLocation();
    const query = useQuery().toString();

    const handleClick = useCallback((event, dataElement, value) => {
        event.preventDefault();
        onClick(dataElement, value);
    }, [onClick]);

    const isActive = useMemo(() => (
        active || (url + dataElement === location.pathname + (query ? "?" + query : ""))
    ), [url, dataElement, query, location.pathname, active]);

    const callbackButtons = useMemo(() => callbacks ? Object.values(callbacks).map(({ hiddenIndices, variant, icon, disabled, callback }, i) => {
        if (hiddenIndices && hiddenIndices.includes(index)) {
            return null;
        }

        return (
            <Button
                variant={typeof variant === 'function' ? variant(index, dataElement) : variant}
                className='ms-1 border-0 p-0'
                disabled={typeof disabled === 'function' ? disabled(index, dataElement) : disabled}
                onClick={disabled ? null : (event) => callback(event, dataElement, value)}
                key={i}
            >
                <Icon icon={typeof icon === 'function' ? icon(index, dataElement) : icon} />
            </Button>
        );
    }) : null, [callbacks, dataElement, value, index]);

    const clickableListItem = useMemo(() => (
        <button
            className={`${CLASS_NAME} list-group-item-action ${isActive ? "active" : ""} ${css}`}
            data-element={dataElement}
            onClick={(event) => handleClick(event, dataElement, value)}
        >
            {value}
        </button>
    ), [isActive, dataElement, value, css, handleClick]);

    const readOnlyListItem = useMemo(() => (
        <div
            className={`${CLASS_NAME} ${isActive ? "active" : ""} ${disabled ? "disabled-background" : ""} ${css}`}
            data-element={dataElement}
        >
            {value}
        </div>
    ), [isActive, disabled, dataElement, value, css]);

    const draggableListItem = useMemo(() => (
        <SortableItem
            index={index}
            styles={{
                default: `${CLASS_NAME_SORTABLE} ${isActive ? "active" : ""} ${disabled ? "disabled-background" : ""}`,
                dragging: `${CLASS_NAME_SORTABLE} ${isActive ? "active" : ""} ${disabled ? "disabled-background" : ""}`,
            }}
            {...drag}>
            {value}
        </SortableItem>
    ), [drag, isActive, disabled, value, index]);

    return (
        <div className="d-flex justify-content-between" key={index}>
            {drag ? draggableListItem : (onClick ? clickableListItem : readOnlyListItem)}
            {callbackButtons}
        </div>
    );
};

export default ListItem;